export default __webpack_public_path__ + "static/samantha-henry-00276c09f7f610eea08b1475e8da8658.png";